import './OfferStatusChoices.scss'

import React from 'react'
import {
  AGENT_OFFER_STATUS_LISTING_INITIAL_SHORT,
  AGENT_OFFER_STATUS_SELLING_INITIAL_SHORT,
} from 'common/constants'
import cx from 'classnames'
import { connect } from 'react-redux'
import { updateOfferStatus } from 'manager/redux/referral_status'


export const OfferStatusChoices = ({ selected, transactionType, updateOfferStatus }) => {
  const choices = transactionType === 'list' ? AGENT_OFFER_STATUS_LISTING_INITIAL_SHORT : AGENT_OFFER_STATUS_SELLING_INITIAL_SHORT

  return (
    <div className="OfferStatusChoices">
      <div className="subtitle">OFFER STATUS</div>
      <div className="choice-btns">
        {choices.map(({ label, value }) => (
          <button
            key={value}
            onClick={() => updateOfferStatus(value)}
            className={cx('StatusChoice', {
              'StatusChoice__selected': selected === value
            })}>
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}

const selector = state => {
  const selected = _.get(state, ['referralStatus', 'offer_status'])
  const transactionType = _.get(state, ['referral', 'referral', 'transaction_type'])


  return {
    selected,
    transactionType,
  }
}

const actions = {
  updateOfferStatus,
}

export const OfferStatusField = connect(selector, actions)(OfferStatusChoices)
